import { Injectable , Inject} from '@angular/core';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent} from 'src/app/shared/base/base.component';
import { Observable,of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeliveryScheduleMaintenanceService {
    
  constructor(
    private webApiService: WebApiService,
    private Environment: EnvironmentconfigService,
    private BaseComponent: BaseComponent,
    ) { }
  // 获取查询表格数据
  getResultData(pageSize,pageIndex,data): Observable<BaseComponent> {

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.wmsm001GetBuyerOrVendorDList.url}`;
    const params = {
      pageSize: pageSize,
      pageIndex: pageIndex,
      data: data
    };
    // 返回一个 Observable，在 subscribe 内部处理数据
    return new Observable<BaseComponent>((observer) => {
      this.webApiService.doPost(url, params).subscribe(
        (res) => {
          if (res && res.status == this.Environment.authConfig.wmsmStatus) {
            var list = res.data.map((item) => {
              item.deliveryDate = DateUtil.formatYMD(item.deliveryDate);
              item.vDate = DateUtil.formatYMD(item.vDate);
              item.uDate = DateUtil.formatYMD(item.uDate);
              return item;
            });
            this.BaseComponent.Result.data = list;
            this.BaseComponent.Result.total = res.total;
            this.BaseComponent.Result.msg = res.msg;  
            this.BaseComponent.Result.status =res.status;
          } else {
            this.BaseComponent.Result.total = 0;
            this.BaseComponent.Result.status ='0000';
            this.BaseComponent.Result.data = [];
            this.BaseComponent.Result.msg = res.msg;
          }
          
          // 在数据处理完后，通过 observer 发送数据
          observer.next(this.BaseComponent);
          observer.complete();
        },
        (error) => {
          // 如果出现错误，通过 observer 发送错误信息
          observer.error(error);
        }
      );
    });
  }
}
